module.exports = __webpack_public_path__ + "img/usaflag.659fc322.svg";